module.exports = {"451123100":"富阳镇","451123101":"白沙镇","451123102":"莲山镇","451123103":"古城镇","451123104":"福利镇","451123105":"麦岭镇","451123106":"葛坡镇","451123107":"城北镇","451123108":"朝东镇","451123200":"新华乡","451123201":"石家乡","451123203":"柳家乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/451123.json
// module id = 1982
// module chunks = 0